import {Component, OnInit, HostListener} from '@angular/core';
import {faBars} from '@fortawesome/free-solid-svg-icons/faBars';
import {NavigationEnd, Router} from '@angular/router';
import {ClientService} from '../../services/client.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html' ,
    styleUrls: ['./nav-bar.component.scss'] 
})
export class NavBarComponent implements OnInit {

    faBars: any;
    showDropDown: boolean;
    navbarElement: HTMLElement;
    navbarDropdown: HTMLElement;
    navbarProperties: any;
    inContracts: boolean;
    inContractDetails: boolean;
    inData: boolean;
    inContratSumary: boolean;
    inErrorPayment: boolean;
    inSuccespayment: boolean;
    showPersonalDataNav: boolean;
    responsiveMenu: boolean;
    screenWidth: number;
    responsiveMedia: number;
    textMessage: string;
    modalId = 'logout-modal';
    siteProfile:string;
    links: any;
    constructor(public router: Router, public clientService: ClientService) {
        this.siteProfile= environment.profile
        this.faBars = faBars;
        this.showDropDown = false;
        this.inContracts = false;
        this.inContractDetails = false;
        this.inData = false;
        this.inContratSumary = false;
        this.inErrorPayment = false;
        this.inSuccespayment = false;
        this.showPersonalDataNav = false;
        this.responsiveMenu = false;
        this.screenWidth = window.innerWidth;
        this.responsiveMedia = 991.98;
        this.textMessage = '¿Seguro que quiere cerrar sesión?';
        this.links=environment.links;
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.navbarHeightHandler();
        this.adjustDropDopDownContent();
        if (window.innerWidth >= this.responsiveMedia) {
            this.navbarDropdown.classList.remove('active');
        } else {
            this.showDropDown = false;
        }
        if (window.innerWidth >= this.responsiveMedia || !this.showDropDown) {
            this.navbarDropdown.style.borderBottom = 'none';
        } else {
            if (this.navbarDropdown.classList.contains('active')) {
                // this.navbarDropdown.style.borderBottom = '2px solid #EA8118';
            }
        }
    }

    @HostListener('window:scroll', ['$event'])
    doSomethingOnInternalScroll() {
        const scrollOffset = window.pageYOffset;
        if (scrollOffset > 0) {
            this.navbarElement.classList.add('mt-0');
        } else {
            this.navbarElement.classList.remove('mt-0');
        }
    }

    @HostListener('window:load', ['$event'])
    load() {
        this.navbarHeightHandler();
    }

    ngOnInit(): void {
        this.navbarDropdown = document.getElementById('navbar-dropdown');
        this.navbarElement = document.querySelector('.navbar-simple');
        this.adjustDropDopDownContent();
        this.showNavPersonalData();
    }

    navbarHeightHandler() {
        this.navbarProperties = this.navbarElement.getBoundingClientRect();
        const navbarDropdownPropereties = this.navbarDropdown.getBoundingClientRect();
        //  document.querySelector('body').style.paddingTop = (this.navbarProperties.height) + 'px';
    }

    togglerDropDown() {
        //this.navbarHeightHandler();
        this.showDropDown = !this.showDropDown;
        if (window.innerWidth >= this.responsiveMedia) {
            this.navbarDropdown.classList.remove('active');
            this.showDropDown = !this.showDropDown;
        }
        if (this.showDropDown) {
            // this.navbarDropdown.style.borderBottom = '2px solid #EA8118';
        } else {
            setTimeout(() => {
                this.navbarDropdown.style.borderBottom = 'none';
            }, 350);
        }
    }

    adjustDropDopDownContent() {
        this.screenWidth = window.innerWidth;
        this.responsiveMenu = this.screenWidth <= this.responsiveMedia;
    }

    showLogOutModal() {
        document.getElementById(this.modalId).classList.remove('d-none');
        this.togglerDropDown();
    }

    showNavPersonalData() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                setTimeout(() => {
                    this.navbarHeightHandler();
                }, 500);
                switch (event.url) {
                    case '/contratos':
                    case '/datos':
                    case '/resumen-de-renovacion':
                    case '/error-de-pago':
                    case '/pago-exitoso':
                        this.showPersonalDataNav = true;
                        break;
                    default:
                        this.showPersonalDataNav = false;
                        break;
                }
                if (!this.showPersonalDataNav) {
                    this.showPersonalDataNav = /[0-9]/g.test(event.url);
                }
            }
        });
    }
}
